import { Grid } from "@mui/material";

import { SegmentDetails } from "./SegmentDetails";
import { TemplateDetails } from "./TemplateDetails";
import { CreateBroadcastDetails } from "./CreateBroadcast";

export default function FormDisplay({ formikProps, editState, setEditState }) {
  return (
    <Grid container spacing={2}>
      {formikProps.values.stagesCount >= 0 && (
        <Grid item xs={12}>
          <CreateBroadcastDetails
            editState={editState}
            formikProps={formikProps}
          />
        </Grid>
      )}

      {formikProps.values.stagesCount >= 1 && (
        <Grid item xs={12}>
          <SegmentDetails formikProps={formikProps} />
        </Grid>
      )}

      {formikProps.values.stagesCount >= 2 && (
        <Grid item xs={12}>
          <TemplateDetails formikProps={formikProps} editState={editState} />
        </Grid>
      )}
    </Grid>
  );
}
